import { isAxiosError } from "axios";
import type {
  CompanyBiometricDeviceRecord,
  CompanyBiometricDeviceUpsertPayload,
} from "@/lib/admin/companyBiometricDevicesStore";

export type CompanyBiometricDeviceFormState = {
  companyId: string;
  warehouseId: string;
  biometricDeviceId: string;
  serialNumber: string;
  ipAddress: string;
  port: string;
  communicationPassword: string;
  location: string;
  isActive: boolean;
};

export const emptyCompanyBiometricDeviceForm = (companyId = ""): CompanyBiometricDeviceFormState => ({
  companyId,
  warehouseId: "",
  biometricDeviceId: "",
  serialNumber: "",
  ipAddress: "",
  port: "4370",
  communicationPassword: "",
  location: "",
  isActive: true,
});

export function companyBiometricDeviceToForm(record: CompanyBiometricDeviceRecord): CompanyBiometricDeviceFormState {
  return {
    companyId: String(record.companyId),
    warehouseId: record.warehouseId ?? "",
    biometricDeviceId: String(record.biometricDeviceId),
    serialNumber: record.serialNumber ?? "",
    ipAddress: record.ipAddress,
    port: String(record.port ?? 4370),
    communicationPassword: record.communicationPassword ?? "",
    location: record.location ?? "",
    isActive: record.isActive,
  };
}

export function companyBiometricDeviceFormToPayload(form: CompanyBiometricDeviceFormState): CompanyBiometricDeviceUpsertPayload {
  const portNum = Number(form.port);
  return {
    companyId: form.companyId.trim(),
    warehouseId: form.warehouseId.trim() || null,
    biometricDeviceId: form.biometricDeviceId.trim(),
    serialNumber: form.serialNumber.trim() || null,
    ipAddress: form.ipAddress.trim(),
    port: Number.isFinite(portNum) && portNum >= 1 && portNum <= 65535 ? portNum : 4370,
    communicationPassword: form.communicationPassword.trim() || null,
    location: form.location.trim() || null,
    isActive: form.isActive,
  };
}

export function companyBiometricDeviceFormErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    const data = error.response?.data as { message?: string; errors?: Record<string, string[]> } | undefined;
    if (data?.errors) {
      const first = Object.values(data.errors).flat()[0];
      if (first) return first;
    }
    if (typeof data?.message === "string") return data.message;
  }
  if (error instanceof Error && error.message) return error.message;
  return "Something went wrong. Please try again.";
}
